import { ActionTypeCreator } from 'app-webtech-core/actions/actionType';

const ActionType = new ActionTypeCreator('LAYOUT');

export const SHOW_WELCOME_SCREEN = ActionType.simple('SHOW_WELCOME_SCREEN');
export const HIDE_WELCOME_SCREEN = ActionType.simple('HIDE_WELCOME_SCREEN');
export const OPEN_MENU = ActionType.simple('OPEN_MENU');
export const CLOSE_MENU = ActionType.simple('CLOSE_MENU');
export const UI_LOADED = ActionType.simple('UI_LOADED');
export const SECTION_SELECT = ActionType.simple('SECTION_SELECT');
